const defaultToast = {
  duration: 3000,
  color: 'medium'
  // buttons: ['OK']
};

export const presentToast = (options) => {
  const toast = document.createElement('ion-toast');
  Object.entries({ ...defaultToast, ...options }).forEach(([key, value]) => {
    toast[key] = value;
  });
  document.body.appendChild(toast);
  return toast.present();
};

export default {
  confirm: function (options) {
    const alert = document.createElement('ion-alert');
    Object.entries(options).forEach(([key, value]) => {
      alert[key] = value;
    });
    document.body.appendChild(alert);
    return alert.present();
  },
  success: function (message, _options = {}) {
    const options = { ...defaultToast, message, color: 'success', ..._options };
    return presentToast(options);
  },
  error: function (message, _options = {}) {
    const options = { ...defaultToast, message, color: 'danger', ..._options };
    return presentToast(options);
  },
  errors: function (error, _options) {
    const options = { ...defaultToast, color: 'danger', ..._options };
    if (typeof error === 'string') {
      options.message = error;
    } else if (
      (error.message &&
        error.errors &&
        Object.values(error.errors).length === 0) ||
      (!error.errors && error.message)
    ) {
      options.message = error.message;
    } else if (error.errors && Object.values(error.errors).length === 1) {
      options.message = Object.values(error.errors)[0];
    } else if (error.errors && Object.values(error.errors).length > 1) {
      const length = Object.values(error.errors).length;
      options.message = `${length} errors occurred`;
    } else {
      options.message =
        'Something went wrong. Please try again or refresh the page if the problem persists.';
    }
    return presentToast(options);
  }
};
